/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import CheckCircleFilled from '@ant-design/icons/lib/icons/CheckCircleFilled';
import CloseCircleFilled from '@ant-design/icons/lib/icons/CloseCircleFilled';
import { Radio } from 'antd';

import './quizReview.less';

interface IQuizOption {
  indicator?: string;
  title: any;
  explanation: any;
  isCorrect: boolean;
}

interface IQuizReviewProps {
  question: any;
  options: IQuizOption[];
  quizIndex: number;
  answer: IQuizOption;
  language: string;
}
const RESULTS = {
  CORRECT: 'correct',
  WRONG: 'wrong',
};
const INDICATORS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

const QuizReview: React.FunctionComponent<IQuizReviewProps> = (props) => {
  const { question, options, quizIndex, answer, language } = props;
  options.forEach((item, index) => {
    item.indicator = INDICATORS[index];
  });

  const getAnswerStyle = (option: IQuizOption) =>
    option.isCorrect
      ? RESULTS.CORRECT
      : option.indicator === answer.indicator
      ? RESULTS.WRONG
      : '';
  const settings =
    language === 'en'
      ? {
          headerLabel: 'Quiz',
          titleLabel: 'Select the correct answer',
          analysisLabel: 'Correct answer analysis',
        }
      : language === 'sc'
      ? {
          headerLabel: '小测验',
          titleLabel: '选择正确的答案',
          analysisLabel: '正确答案解析',
        }
      : {
          headerLabel: '小測驗',
          titleLabel: '選擇正確的答案',
          analysisLabel: '正確答案解析',
        };
  return (
    <div className="review-quiz-section">
      <div className="review-quiz-section-body">
        <div className="quiz-title">{settings?.titleLabel}</div>
        <div
          className="quiz-question"
          dangerouslySetInnerHTML={{
            __html: `${quizIndex}. ${question[language]} `,
          }}
        />
        <div className="quiz-answers">
          <Radio.Group value={answer.indicator}>
            {options.map((option: IQuizOption, index) => (
              <div
                key={index}
                className={`quiz-answers-item ${getAnswerStyle(option)}`}
              >
                <Radio value={option.indicator}>
                  {getAnswerStyle(option) === RESULTS.CORRECT ? (
                    <CheckCircleFilled />
                  ) : null}
                  {getAnswerStyle(option) === RESULTS.WRONG ? (
                    <CloseCircleFilled />
                  ) : null}
                  {option.indicator}. {option.title[language]}
                </Radio>
              </div>
            ))}
          </Radio.Group>
        </div>
        <div className="quiz-result-area">
          <div className="text">{settings.analysisLabel}</div>
          <p
            dangerouslySetInnerHTML={{
              __html:
                options.find((itm) => itm.isCorrect)?.explanation[language] ||
                '',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default QuizReview;
